import { OpenFeature } from '@openfeature/react-sdk';

import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';

/**
 * Release gate for persisting table column widths across the markdown
 * round-trip. OFF (default): colwidths markers in stored markdown are still
 * consumed and hidden, but widths are not stamped onto table cells, and the
 * serializer does not emit markers — resized widths revert to auto layout on
 * reload (current behaviour). ON: the reader stamps widths and the serializer
 * emits the marker.
 *
 * One flag covers both halves so a single flip is the remote off-switch for
 * the whole feature. Marker hiding is intentionally NOT gated — a reserved
 * system comment must never render as text, killed or not. Neither are the
 * table drag affordances: resize and drag already ship unconditionally in the
 * v1 and markdown-native editors, so gating them here would only make the same
 * note behave differently depending on which editor opened it.
 *
 * Treat ON as one-way. Turning it back off discards widths saved while it was
 * on: the reader consumes the marker without stamping, so the next save writes
 * the table back without it. Deliberate — stopping emission is the point of the
 * kill switch, and widths are cosmetic — but it is not a lossless off-switch.
 *
 * Called outside React (markdown helpers), so non-hook only. Lives in this
 * standalone `.ts` module (not the `index.tsx` barrel) so the reader does not
 * add a `react-refresh/only-export-components` warning to the component
 * barrel.
 */
export const isTableColwidthPersistenceEnabled = () => {
  return OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'release-scribe-table-colwidth-persistence',
    false
  );
};
